import ReactDOM from "react-dom/client";
//
import "./styles/index.scss";
import "./index.css";
import "./fonts/line-awesome-1.3.0/css/line-awesome.css";
import "rc-slider/assets/index.css";

//
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { persistor, store } from "app/store";
import { PersistGate } from "redux-persist/integration/react";
import {
  createHttpLink,
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import config from "./configFile";
import ReactGA4 from "react-ga4";

ReactGA4.initialize("G-VJBKPX10VF");
ReactGA4.initialize("G-JLFK8VKZ1H");
ReactGA4.initialize("G-G90D0HEVV6");

const httpLink = createHttpLink({
  uri: config.ip,
});

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token =
    localStorage.getItem("token") ||
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiJjbGJrcnJ6ZWowMDRmNDQxbmM3bDJhNnh5Iiwicm9sZSI6IkFETUlOIiwiaWF0IjoxNzY0OTI0NDUyfQ.bq5_bxWD-0zanatPuUG3HEZZwdcmGXWdtYB1dVNBA8s";

  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
      // authorization: `Bearer ${token_test}`,
    },
  };
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache() as any,
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <ApolloProvider client={client}>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </ApolloProvider>
);

reportWebVitals();
